import React from 'react';
import FloatingWrapper from './FloatingWrapper';

interface FilterClearButtonProps {
  handleClick: () => void;
  isDesktop: boolean;
}

const FilterClearButton: React.FC<FilterClearButtonProps> = props => {
  const { isDesktop } = props;
  return (
    <FloatingWrapper isDesktop={isDesktop} style={{ backgroundColor: '#FFF', padding: '5px', zIndex: 1 }}>
      <a onClick={() => props.handleClick()} style={{ color: '#000' }}>
        clear
      </a>
    </FloatingWrapper>
  );
};

export default FilterClearButton;
